import { Grid, LinearProgress, Typography } from "@mui/material";
import omit from "lodash/omit";
import type { FC } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import CancelButton from "../../components/cancelButton/CancelButton";
import type { ProviderFormState } from "./ProviderEdit";
import ProviderEdit from "./ProviderEdit";
import ProviderFiles from "./ProviderFiles";
import type { ProviderResponse } from "./providersApi";
import { useProvider } from "./useProvider";

const ReadOnlyProviderView: FC<{ readonly provider: ProviderResponse }> = ({ provider }) => {
  const { control } = useForm<ProviderFormState>({
    defaultValues: {
      ...omit(provider, "id", "files", "listTemplate"),
      taxInfo: {
        ...provider.taxInfo,
        skipValidation: false,
      },
    },
  });

  return (
    <ProviderEdit
      control={control}
      disabled
      files={
        <ProviderFiles providerId={provider.id} files={provider.files} listTemplate={provider.listTemplate} readOnly />
      }
    />
  );
};

const ReadOnlyProviderPage = () => {
  const navigate = useNavigate();
  const { provider, isLoading } = useProvider();

  if (isLoading) {
    return (
      <Grid container>
        <Grid size={12}>
          <LinearProgress data-testid="loading-indicator" />
        </Grid>
      </Grid>
    );
  }

  if (!provider) {
    return (
      <Grid
        container
        spacing={2}
        sx={{
          marginTop: 1,
          marginBottom: 1,
        }}
      >
        <Typography
          sx={{
            margin: 2,
          }}
        >
          Taki dostawca nie istnieje
        </Typography>
      </Grid>
    );
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{
        marginTop: 1,
        marginBottom: 1,
        paddingLeft: 1,
        paddingRight: 1,
      }}
    >
      <ReadOnlyProviderView provider={provider} />
      <Grid
        size={12}
        container
        sx={{
          justifyContent: "flex-end",
        }}
      >
        <CancelButton onClick={() => navigate("/admin/providers")} />
      </Grid>
    </Grid>
  );
};

export default ReadOnlyProviderPage;
